<template>
  <section class="hero_section">
    <ParticalsComponent />

    <article
      v-for="(post, postIndex) in heroSectionData"
      :key="postIndex"
      :class="{
        content: true,

        active: index === postIndex,
        hide: lastIndex === postIndex,
      }"
      @animationend="animationEnd($event, lastIndex === postIndex)"
    >
      <div class="img_side">
        <img
          :src="getImgUrl(post.image_name)"
          alt="Ps Software Landing page"
          draggable="false"
        />
      </div>
      <div class="desc_side">
        <p>
          {{ post.title }}
        </p>
        <button
          v-if="post.btnText && post.btnText !== ''"
          @click="navigateTo(post.btnNavigationLink)"
        >
          {{ post.btnText }}
        </button>
      </div>
    </article>
    <div class="three_dots_container">
      <span
        v-for="(item, ind) in heroSectionData"
        :key="ind"
        :class="{ active: index === ind }"
        @click="changeSliderData(ind)"
      ></span>
    </div>
    <div class="hero_footer"></div>
  </section>
</template>

<script>
import store from "@/store";
import ParticalsComponent from "@/components/ParticalsComponent";
import { getImgUrl } from "@/util/methods";
export default {
  name: "HeroSection",

  data() {
    return {
      index: 0,
      lastIndex: -1,
      interval: null,
    };
  },
  components: {
    ParticalsComponent,
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getNextSildeItem();
    }, 7500);
  },
  unmounted() {
    this.interval && clearInterval(this.interval);
  },
  computed: {
    heroSectionData() {
      const { lang } = store.state;
      return store.state[lang].homePage.heroSection;
    },
  },
  methods: {
    getImgUrl,
    navigateTo(dest) {
      if (dest) {
        this.$router.push(dest);
      }
    },
    changeSliderData(ind) {
      if (ind != this.index) {
        this.lastIndex = this.index;
        this.index = ind;
      }
    },
    animationEnd(post, isHide) {
      if (isHide) {
        post.currentTarget.classList.remove("hide");
      }
    },
    getNextSildeItem() {
      let currentIndex = this.index;
      const length = this.heroSectionData.length;
      if (length) {
        currentIndex = (currentIndex + 1) % this.heroSectionData.length;
        this.changeSliderData(currentIndex);
      }
    },
  },
};
</script>
